export default {
    data() {
        return {}
    },
    created() {
        this.$store.commit('setPageWidgetFocusTrue')
        this.$root.$on('soundNewMessage', this.emitSoundNewMessage)
        document.addEventListener('visibilitychange', this.visibilitychange)
    },
    beforeDestroy() {
        document.removeEventListener('visibilitychange', this.visibilitychange)
        this.$root.$off('soundNewMessage', this.emitSoundNewMessage)
    },
    methods: {
        visibilitychange() {
            if (!document.hidden) {
                this.$store.commit('setPageWidgetFocusTrue')
            } else {
                setTimeout(() => {
                    this.$store.commit('setPageWidgetFocusFalse')
                }, 100)
            }
        },
        emitSoundNewMessage() {
            if (!this.$store.state.api.options.sound_new_message) return

            if (!this.$store.state.chatActive || !this.$store.state.pageWidgetFocus) {
                let audio = new Audio(this.$store.state.api.options.sound_new_message_link)
                //let audio = new Audio('default.mp3')
                audio.volume = 0.1
                audio.play()
            }
        }
    }
}
